import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  ModalHeader,
  useDisclosure,
  Center,
  useToast,
  Text,
  HStack,
} from "@chakra-ui/react";
import { useEffect, useState, useRef } from "react";
import {
  useUploadAssetMutation,
  useGetAssetVersionQuery,
} from "./index.generated";

export const AssetVersionModal = ({ courseId }: { courseId: string }) => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [uploadAssetRes, upload] = useUploadAssetMutation();
  const [getAssetVersion] = useGetAssetVersionQuery({
    variables: { id: courseId },
  });
  const [newAssetVersionMajor, setNewAssetVersionMajor] = useState(0);
  const [newAssetVersionMinor, setNewAssetVersionMinor] = useState(0);
  const [newAssetVersionPatch, setNewAssetVersionPatch] = useState(0);
  let nowVersion = "設定されていません";

  useEffect(() => {
    if (getAssetVersion.data?.course.assetVersion) {
      nowVersion = getAssetVersion.data?.course.assetVersion;
      const versionArray = nowVersion.split(".").map((v) => parseInt(v));

      setNewAssetVersionMajor(versionArray[0]);
      setNewAssetVersionMinor(versionArray[1]);
      setNewAssetVersionPatch(versionArray[2] + 1);
    }
  }, [getAssetVersion.data]);

  const uploadAsset = () => {
    upload({
      id: courseId,
      assetVersion: `${newAssetVersionMajor}.${newAssetVersionMinor}.${newAssetVersionPatch}`,
    }).then((res) => {
      if (res.error) {
        if (res.error.message.includes("Spot Asset ID is invalid")) {
          toast({
            title: "スポットIDは0~9999の範囲で指定してください",
            status: "warning",
          });
        } else if (res.error.message.includes("Course Asset ID is invalid")) {
          toast({
            title: "コースIDは0~999の範囲で指定してください",
            status: "warning",
          });
        } else if (
          res.error.message.includes("Course is not visible to all user groups")
        ) {
          toast({
            title: "コースが公開されていません",
            status: "warning",
          });
        } else {
          toast({
            title: "画像のアップロードに失敗しました",
            status: "error",
          });
          console.error(res.error);
        }
      } else {
        toast({ title: "画像をアップロードしました", status: "success" });
        onClose();
      }
    });
  };

  return (
    <>
      {import.meta.env.VITE_FEATURE_FLAG_ENABLE_ASSET_EDITOR == "true" && (
        <Button
          onClick={() => {
            onOpen();
          }}
          size="sm"
          variant="outline"
          textColor="white"
          rounded="full"
        >
          画像変更の反映
        </Button>
      )}
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={"xs"}
        scrollBehavior="inside"
      >
        <ModalContent bgColor="gray.900" color="white">
          <ModalHeader>バージョンの更新</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>現在のバージョン : {nowVersion}</Text>
            <HStack w="full" justify="center">
              <NumberInput
                value={newAssetVersionMajor}
                min={0}
                width="20"
                onChange={(str, num) => {
                  setNewAssetVersionMajor(num);
                }}
                allowMouseWheel
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper textColor={"white"} />
                  <NumberDecrementStepper textColor={"white"} />
                </NumberInputStepper>
              </NumberInput>
              <Text fontSize={20}>.</Text>
              <NumberInput
                value={newAssetVersionMinor}
                min={0}
                width="20"
                onChange={(str, num) => {
                  setNewAssetVersionMinor(num);
                }}
                allowMouseWheel
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper textColor={"white"} />
                  <NumberDecrementStepper textColor={"white"} />
                </NumberInputStepper>
              </NumberInput>
              <Text fontSize={20}>.</Text>
              <NumberInput
                value={newAssetVersionPatch}
                min={0}
                width="20"
                onChange={(str, num) => {
                  setNewAssetVersionPatch(num);
                }}
                allowMouseWheel
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper textColor={"white"} />
                  <NumberDecrementStepper textColor={"white"} />
                </NumberInputStepper>
              </NumberInput>
            </HStack>
            <Box height={10}></Box>
            <Center>
              <Button
                backgroundColor="transparent"
                variant="outline"
                textColor={"white"}
                rounded="full"
                onClick={() => {
                  // createZip(assetList);
                  uploadAsset();
                }}
              >
                画像を更新する
              </Button>
            </Center>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
